import { get, post, update, get2, upload, download } from "./helpers";

export function resetAkun($data) {
  return post("/reset-akun", $data);
}

// API GENERAL
export function downloadFileDashboard(filename) {
  return download(`/general/dashboard/download/dokumen/${filename}`);
}
export function getUserDetail(uuid) {
  return get(`/general/user/detail?uuid=${uuid}`);
}
export function getUserDetailDashboard(uuid) {
  return get(`/general/user/detail?dashboard=true&uuid=${uuid}`);
}
export function uploadFoto(file, metadata, onUploadProgress) {
  return upload("/general/user/uploadfile", file, metadata, onUploadProgress);
}
export function ubahUserData($data) {
  return post("/general/user/detail/update", $data);
}
export function getDetailHasilSidang(uuid) {
  return get(`/general/hasil-kajietik/detail/${uuid}`);
}
export function updateCatatanHasilSidang($data) {
  return post("/general/hasil-kajietik/catatan/update", $data);
}
export function updateJawabanPenilaianHasilSidang($data) {
  return post("/general/hasil-kajietik/jawaban-penilaian/update", $data);
}
// END API GENERAL

//API ADMIN
export function activationUser($data) {
  return post("/admin/pengguna/activation", $data);
}
export function postPengguna($data) {
  return post("/admin/pengguna/post", $data);
}
export function postRegister($data) {
  return post("/account/register", $data);
}
export function postLupaPassword($data) {
  return post("/lupa-password", $data);
}
export function postResetPassword($data) {
  return post("/reset-password", $data);
}
export function updateStatusByAdmin($data) {
  return post("/admin/status-hasil-kajietik/update", $data);
}
export function generateDosen($data) {
  return get("/admin/bulkRegisterFromDosen", $data);
}
//END API ADMIN

// API MAHASISWA
export function postBerkas() {
  return post("/mahasiswa/pengajuan-kajietik/baru");
}
export function updateBerkas($data) {
  return update("/mahasiswa/pengajuan-kajietik/update", $data);
}


export function getPengajuanSidangDetailByHasil(pengajuanId) {
  return get(`/mahasiswa/pengajuan-kajietik/detail-hasil/${pengajuanId}`);
}

export function getPengajuanSidangDetail(pengajuanId) {
  return get(`/mahasiswa/pengajuan-kajietik/detail/${pengajuanId}`);
}
export function uploadFilePengajuan(file, metadata, onUploadProgress) {
  return upload(
    "/mahasiswa/pengajuan-kajietik/uploadfile",
    file,
    metadata,
    onUploadProgress
  );
}
export function downloadDokumen(filename) {
  return download(`/mahasiswa/pengajuan-kajietik/download/dokumen/${filename}`);
}
export function deletePengajuanSidang(uuid) {
  return post(`/mahasiswa/pengajuan-kajietik/delete/${uuid}`);
}
export function updateBerkasHasilSidang($data) {
  return update("/mahasiswa/berkas-hasil-kajietik/update", $data);
}
export function uploadFileBerkasHasilSidang(file, metadata, onUploadProgress) {
  return upload(
    "/mahasiswa/berkas-hasil-kajietik/uploadfile",
    file,
    metadata,
    onUploadProgress
  );
}
export function downloadBerkasHasilSidang(filename) {
  return download(
    `/mahasiswa/berkas-hasil-kajietik/download/dokumen/${filename}`
  );
}
// END API MAHASISWA

// API PEMBIMBING
export function postTerimaBerkas($data) {
  return post("/pembimbing/terima-berkas", $data);
}
export function postTolakBerkas($data) {
  return post("/pembimbing/tolak-berkas", $data);
}
export function postMulaiSidang($data) {
  return post("/pembimbing/mulai-kajietik", $data);
}
export function updateStatusHasilSidang($data) {
  return post("/pembimbing/status-hasil-kajietik", $data);
}
export function postPermintaanPerubahanNilai($data) {
  return post("/pembimbing/perubahan-nilai", $data);
}
export function postTandaiSelesai($data) {
  return post("/pembimbing/selesai", $data);
}
export function downloadSuratLolos($id) {
  return download(`general/kajietik/download/${$id}/pdf`);
}
// END API PEMBIMBING

// MASTER DATA
export function getJenisKelamin() {
  return get("/general/master/jenis-kelamin");
}
export function getJurusan() {
  return get("/general/master/jurusan");
}
export function getJenjang() {
  return get("/general/master/jenjang");
}
export function getProdi() {
  return get("/general/master/prodi");
}
export function getPeminatan() {
  return get("/general/master/peminatan");
}
export function getProvinsi() {
  return get("/general/master/provinsi");
}
export function getKota(provinsiId) {
  return get(`/general/master/kota/${provinsiId}`);
}
export function getJenisSidang() {
  return get("/general/master/jenis-kajietik");
}
export function getProsesPersidangan() {
  return get("/general/master/proses-kajietik");
}
export function getDosen() {
  return get("/general/master/dosen");
}
export function getDosenReviewer() {
  return get("/general/master/dosen-reviewer");
}
export function getRuangan() {
  return get("/general/master/ruangan");
}
export function getRole() {
  return get("/general/master/role");
}
export function getProgram() {
  return get("/general/master/program");
}
export function getWaktuUjian() {
  return get("/general/master/waktu-ujian");
}
export function getJawabanPersetujuan() {
  return get("/general/master/jawaban-persetujuan");
}
export function getStatusHasilSidang() {
  return get("/general/master/status-hasil-kajietik");
}
export function getStatusPengajuanSidang() {
  return get("/general/master/status-pengajuan-kajietik");
}
export function getStatusJadwalSidang() {
  return get("/general/master/status-jadwal-kajietik");
}
export function getTotalDosenTanpaAkun() {
  return get("/general/master/dosen-tanpa-akun");
}
// END MASTER DATA

export function getTokenSso(secret) {
  return get(`/get-token-sso/${secret}`)
}
